import { useRouter } from "next/router";
import { ReviewsUI } from "./ReviewsUI";
import { StandardProps } from "../componentMap";
import { getBaseUrlAndQuery } from "@/utils/url/getBaseUrlAndQuery";

export function Reviews({
  product,
  runtimeConfig,
  configProps,
  experiencesRawObject,
  flags,
}: Pick<
  StandardProps,
  "product" | "runtimeConfig" | "configProps" | "experiencesRawObject" | "flags"
>) {
  const { asPath } = useRouter();
  const { baseUrl } = getBaseUrlAndQuery(asPath);
  const { reviewsApiKey, reviewsScriptUrl } = runtimeConfig;
  const isWide = flags.isWide?.value === true;

  return (
    <ReviewsUI
      productId={product.aliases.pimProductId}
      reviewsApiKey={reviewsApiKey}
      reviewsScriptUrl={reviewsScriptUrl}
      productUrl={baseUrl}
      numberOfReviews={product.reviewSummary?.numberOfReviews}
      media={configProps?.hideReviewsMedia ? "false" : "true"}
      experiencesRawObject={experiencesRawObject}
      isWide={isWide}
    />
  );
}
